import { Box, PargodaRoundButton, Typography, styled } from '../../../../base';

export const FieldRow = styled(Box)(({ theme }) => ({
    display: 'flex',
    alignItems: 'center',
    borderBottom: `1px solid ${theme.palette.divider}`,
    padding: theme.spacing(0.75, 0),
    gap: theme.spacing(1),
    minHeight: 40,
}));

export const FieldLabel = styled(Typography)(({ theme }) => ({
    minWidth: 60,
    color: theme.palette.grey[500],
    fontSize: 14,
    fontWeight: 500,
}));

export const FieldContent = styled(Box)(() => ({
    flex: 1,
    display: 'flex',
    alignItems: 'center',
}));

export const CcBccToggle = styled(Typography)(() => ({
    fontSize: 14,
    cursor: 'pointer',
    userSelect: 'none',
    '&:hover': {
        opacity: 0.7,
    },
}));

export const FooterRow = styled(Box)(() => ({
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
}));

export const EditorWrapper = styled(Box)(({ theme }) => ({
    '&& .ql-toolbar': {
        display: 'flex',
        alignItems: 'center',
        flexWrap: 'wrap',
        border: 'none',
        borderBottom: `1px solid ${theme.palette.divider}`,
        borderRadius: 0,
        padding: theme.spacing(1, 0),
    },
    '&& .ql-container': {
        border: 'none',
        borderBottom: `1px solid ${theme.palette.divider}`,
        borderRadius: 0,
    },
    '&& .ql-editor': {
        height: '250px',
        padding: theme.spacing(1.5, 0),
    },
}));

export const SendButton = styled(PargodaRoundButton)(({ theme }) => ({
    background: `linear-gradient(0deg, ${theme.palette.primary.main}, ${theme.palette.primary.dark})`,
    minWidth: '120px',
    fontWeight: 600,
    fontSize: '16px',
}));
